import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CreateExhibitorDialog from '../exhibitor-list/create-exhibitor-dialog';

/** @class ExhibitorSelect
  * A component to allow the selection of an exhibitor
  * @param {string} value - the selected exhibitorID
  * @param {function} onChange - an event handler for a change event
  */
export default class ExhibitorSelect extends Component {
  /** @constructor
    * Constructs a new instance of ExhibitorSelect
    */
  constructor(props) {
    super(props);
    this.state = {
      showNewDialog: false
    }
    this.handleChange = this.handleChange.bind(this);
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if(value === 'add-new-exhibitor') {
      this.setState({showNewDialog: true});
    } else {
      this.props.onChange(event);
    }
  }
  /** @method render
    * Renders the component
    */
  render() {
    const exhibitors = this.props.exhibitors
    .sort((a,b) => a.company.localeCompare(b.company))
    .map(exhibitor => (
      <option key={exhibitor.id} value={exhibitor.id}>
        {exhibitor.company} / {exhibitor.brand}
      </option>
    ));
    return (
      <div className="input-group">
        <CreateExhibitorDialog show={this.state.showNewDialog} onExit={() => this.setState({showNewDialog: false})}/>
        <label htmlFor="exhibitorID">Exhibitor</label>
        <select name="exhibitorID" value={this.props.value} onChange={this.handleChange}>
          <option value="">Please Select</option>
          {exhibitors}
          <option value="add-new-exhibitor">[Add New Exhibitor]</option>
        </select>
      </div>
    );
  }
}

ExhibitorSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  exhibitors: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./src/gift-card-editor/exhibitor-select.js